export const removeDuplicatesArray = array => {
  return array.filter((item, index) => array.indexOf(item) === index);
};

export const removeDuplicatedArrayOfObjectsWithUniqueIdByLatestVersion = (
  array: any[],
) => {
  const objectOfArrays = array.reduce((acc, el) => {
    const elId = el.uniqueId;

    if (!(acc && acc[elId])) {
      acc[elId] = [];
    }
    acc[elId].push(el);

    return { ...acc };
  }, {});

  return Object.values(objectOfArrays)
    .map((duplicateArray: any[]) =>
      duplicateArray.filter(x => isLatestVersion(duplicateArray, x)),
    )
    .reduce((acc, x) => [...acc, ...x], []);
};

function isLatestVersion(arr: any[], obj) {
  if (arr.length === 1) {
    return true;
  }
  const latestTimestamp = arr.reduce((acc, x) => {
    const timestamp = x?.updatedAt ? new Date(x.updatedAt).getTime() : 0;
    return timestamp > acc ? timestamp : acc;
  }, 0);

  const objTimestamp = obj?.updatedAt ? new Date(obj.updatedAt).getTime() : 0;

  return objTimestamp >= latestTimestamp;
}
